import { AnyAction } from "redux";
import {
  CLOSE_SIDEBAR, OPEN_SIDEBAR, TOGGLE_SIDEBAR,
  OPEN_MOBILE_SIDEBAR, CLOSE_MOBILE_SIDEBAR, TOGGLE_MOBILE_SIDEBAR,
} from "../types";


export const toggleSidebar = (): AnyAction => ({
  type: TOGGLE_SIDEBAR,
});

export const openSidebar = (): AnyAction => ({
  type: OPEN_SIDEBAR,
});

export const closeSidebar = (): AnyAction => ({
  type: CLOSE_SIDEBAR,
});

export const openMobileSidebar = (): AnyAction => ({
  type: OPEN_MOBILE_SIDEBAR,
});

export const closeMobileSidebar = (): AnyAction => ({
  type: CLOSE_MOBILE_SIDEBAR,
});

export const toggleMobileSidebar = (): AnyAction => ({
  type: TOGGLE_MOBILE_SIDEBAR,
});
